import request from "@/utils/request";

/**
 * 当前用户 common
 * 所有接口需 Header: Authorization: Bearer <access_token>
 */

/**
 * GET /api/v1/me 当前登录信息与权限清单
 * @returns {Promise<R<MeVO>>} { merchantId, memberId, role, boss, authorities }
 */
export function getMe() {
  return request({ url: "/v1/me", method: "get" });
}

/**
 * GET /api/v1/me/permissions 权限码清单（去 perm: 前缀）
 * @returns {Promise<R<List<string>>>} 权限码字符串列表
 */
export function getMyPermissions() {
  return request({ url: "/v1/me/permissions", method: "get" });
}
